import React, { useContext, useEffect, useState } from 'react'

import { Button, Col, Form, Icon, Input, Row, Table, Typography, notification } from 'antd'
import { get, uniqBy } from 'lodash'

import { getMessage } from '../../util/IntlMessages'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import sortText from '../../util/sortText'
import { api, request } from '../../util/handlerRequestUtil'
import GroupIcon from '../../assets/images/group-icon.svg'
import { ActionsPlanContext } from './ActionsPlan'

const AddCustomerList = ({ categoriaAcao, setIsModalLocationVisible, isModalLocationVisible, escapeLocations }) => {
  const {
    filters: { idDistrict }
  } = useContext(ActionsPlanContext)
  const [customers, setCustomers] = useState([])
  const [selectedRows, setSelectedRows] = useState([])
  const [selectedRowsKeys, setSelectedRowsKeys] = useState([])
  const [customerName, setCustomerName] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchCustomers(customerName)
  }, [idDistrict])

  useEffect(() => {
    if (isModalLocationVisible) {
      setSelectedRowsKeys([])
      setCustomerName('')
      fetchCustomers('')
    }
  }, [isModalLocationVisible])

  async function fetchCustomers(customerName) {
    try {
      const params = {
        idDistrict,
        customerName,
        escapeLocations
      }

      const customers = await request(api.getCustomersSearch(params))

      const formatedRows = []
      for (let item of customers) {
        const redText = categoriaAcao.classificacao > item.eibClassificacao
        formatedRows.push({
          key: get(item, 'id'),
          customerName: renderComCor(get(item, 'customer_name'), redText),
          classificacao: renderClassificationAction(get(item, 'eibClassificacao'), redText),
          locationName: renderComCor(get(item, 'location_name'), redText),
          location_id: get(item, 'id'),
          customerType: renderComCor(get(item, 'type_name'), redText),
          totalArea: handleArea(get(item, 'areaPlantada'), redText)
        })
      }
      const formattedCustomers = uniqBy(formatedRows, function (e) {
        return e.location_id
      })
      setCustomers(formattedCustomers)
    } catch (error) {
      console.tron.log(error)
    }
  }

  function handleArea(area) {
    return area ? parseFloat(area).toLocaleString('pt-BR') + ' ha' : '0 ha'
  }

  const renderComCor = (texto, vermelho) => {
    let cor = '#000000'
    if (vermelho) {
      cor = '#FF0000'
    }
    return <div style={{ color: cor }}>{texto}</div>
  }

  function getCategoryActionColumns() {
    const columns = [
      {
        title: getMessage('customerName'),
        dataIndex: 'customerName',
        sorter: (a, b) => sortText(a, b, 'customerName'),
        width: '30%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('customerType'),
        dataIndex: 'customerType',
        sorter: (a, b) => sortText(a, b, 'customerType'),
        width: '15%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('locationName'),
        dataIndex: 'locationName',
        sorter: (a, b) => sortText(a, b, 'locationName'),
        width: '30%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('categoryActionClassificationBayer'),
        dataIndex: 'classificacao',
        sorter: (a, b) => sortText(a, b, 'classificacao'),
        width: '10%',
        align: 'center',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      },
      {
        title: getMessage('totalArea'),
        dataIndex: 'totalArea',
        sorter: (a, b) => sortText(a, b, 'totalArea'),
        width: '15%',
        render: (item, line) => <TableLineDisable item={item} line={line} />
      }
    ]
    return columns
  }

  const renderClassificationAction = (id, vermelho) => {
    let cor = '#000000'
    if (vermelho) {
      cor = '#FF0000'
    }
    return (
      <label style={{ marginRight: 10, color: cor }}>
        <Icon type="star" style={{ color: cor, fontSize: 20 }} />
        {'    ' + id}
      </label>
    )
  }

  async function createLocationsPlains() {
    if (!loading) {
      setLoading(true)
      try {
        let selectionados = uniqBy(selectedRows, function (e) {
          return e.location_id
        })

        for (const row of selectionados) {
          await api.createEibLocationsPlain({ idFazenda: Number(row.location_id), idAcaoEib: categoriaAcao.id })
        }
        notification.success({
          description: getMessage('successStoreCustomers'),
          message: getMessage('sweetAlerts.success')
        })
        setIsModalLocationVisible(false)
        setSelectedRows([])
        setLoading(false)
      } catch (error_) {
        setLoading(false)
        console.tron.log(error_)
      }
    }
  }

  const rowSelection = {
    selectedRowKeys: selectedRowsKeys,
    onChange: (selectedRowKeys, rows) => {
      setSelectedRowsKeys(selectedRowKeys)
      setSelectedRows(rows)
    }
  }

  function renderCustomers() {
    return (
      <div style={{ padding: '2%' }}>
        {customers.length === 0 ? (
          <div style={{ textAlign: '-webkit-center', margin: '10%' }}>
            <div>
              <img src={GroupIcon} alt="" />
              <Typography
                className="default-header-title"
                style={{ color: '#334863', padding: '10px 0px 10px' }}
                level={3}
              >
                {getMessage('emptyCustomerParticipant')}
              </Typography>
            </div>
          </div>
        ) : (
          <Table
            rowSelection={{
              type: 'checkbox',
              ...rowSelection
            }}
            rowKey={(record) => record.location_id}
            columns={getCategoryActionColumns()}
            dataSource={customers}
            pagination={false}
          />
        )}
      </div>
    )
  }

  function setFilterFieldValue(e) {
    setCustomerName(e.target.value)
  }

  function cleanFilter() {
    setSelectedRowsKeys([])
    setCustomerName('')
    fetchCustomers('')
  }

  function renderFilters() {
    return (
      <div className="materials-filters">
        <Form layout="vertical">
          <div>
            <div style={{ paddingLeft: 15 }}>Filtrar por Nome</div>
            <Row type="flex" justify="start">
              <Col span={13}>
                <Input placeholder="Digite Aqui" value={customerName} onChange={setFilterFieldValue} />
              </Col>
              <Col span={5}>
                <Button
                  icon="search"
                  className="fetch-material-btn"
                  type="dashed"
                  disabled={!customerName || customerName.length < 3}
                  onClick={() => fetchCustomers(customerName)}
                >
                  {getMessage('search')}
                </Button>
              </Col>
              <Col span={5}>
                <Button className="cleanFiltersBtn" icon="close" type="ghost" onClick={() => cleanFilter()}>
                  {getMessage('cleanFilters')}
                </Button>
              </Col>
            </Row>
          </div>
        </Form>
        <hr />
      </div>
    )
  }

  return (
    <>
      {renderFilters()}
      {renderCustomers()}
      <div>
        <Button
          className="bgPrimary"
          type="dashed"
          disabled={selectedRows.length === 0 || loading}
          onClick={() => createLocationsPlains()}
        >
          {getMessage('AddSelectedCustomer')}
        </Button>
      </div>
    </>
  )
}

export default AddCustomerList
